import { render, staticRenderFns } from "./LocalTrainingList.vue?vue&type=template&id=0eccc905&"
import script from "./LocalTrainingList.js?vue&type=script&lang=js&"
export * from "./LocalTrainingList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports